/**
 * 软件升级
 */
import request from '@/utils/request';

// 校园列表
export function campusList(params) {
  return request({
    url: `/campus/apps/page`,
    method: 'get',
    params: params
  });
}
// 校园-添加
export function campusAdd(data) {
  return request({
    url: `/op/appConfig/`,
    method: 'POST',
    data
  });
}
// 校园-修改
export function campusUpdate(id, data) {
  return request({
    url: `/op/appConfig/` + id,
    method: 'POST',
    data
  });
}
// 校园-删除
export function campusDelete(id) {
  return request({
    url: `/op/appConfig/` + id,
    method: 'DELETE'
  });
}
// 校园-导出
export function campusExprot(params) {
  return request({
    url: `/campus/apps/export`,
    method: 'get',
    responseType: 'blob',
    params
  });
}

// 家庭
// 家庭列表
export function homeList(params) {
  return request({
    url: `/op/cunwapps/page`,
    method: 'get',
    params: params
  });
}
// 家庭-添加
export function homeAdd(data) {
  return request({
    url: `/op/appConfig/addHomeConfig`,
    method: 'POST',
    data
  });
}
// 家庭-修改
export function homeUpdate(id, data) {
  return request({
    url: `/op/appConfig/updateHomeConfig/` + id,
    method: 'POST',
    data
  });
}
// 家庭-删除
export function homeDelete(id) {
  return request({
    url: `/op/appConfig/deleteHomeConfig/` + id,
    method: 'DELETE'
  });
}
// 家庭-导出
export function homeExprot(params) {
  return request({
    url: `/op/cunwapps/export`,
    method: 'get',
    responseType: 'blob',
    params
  });
}

// 需求2.0 B端 应用管理
// 校园应用列表
export function campusAppsList(params, typeCode) {
  return request({
    url: `/campus/apps/${typeCode}/page`,
    method: 'get',
    params: params
  });
}
// 校园-添加
export function campusAppAdd(data) {
  return request({
    url: `/campus/apps/`,
    method: 'POST',
    data
  });
}
// 校园-修改
export function campusAppUpdate(id, data) {
  return request({
    url: `/campus/apps/` + id,
    method: 'PUT',
    data
  });
}
// 校园-禁用
export function campusAppsDisable(params) {
  return request({
    url: `/campus/apps/disable`,
    method: 'PUT',
    params: params
  });
}
// 校园-启用
export function campusAppEnable(params) {
  return request({
    url: `/campus/apps/enable`,
    method: 'PUT',
    params: params
  });
}

// 查询校园应用学校分组分页列表
export function campusAppGroups(params) {
  return request({
    url: `/campus/app/school/groups/page`,
    method: 'get',
    params: params
  });
}
// 校园应用学校分组-创建
export function campusAppAddGroups(data) {
  return request({
    url: `/campus/app/school/groups/`,
    method: 'POST',
    data
  });
}
// 校园应用学校分组-修改
export function campusAppUpdateGroups(id, data) {
  return request({
    url: `/campus/app/school/groups/` + id,
    method: 'PUT',
    data
  });
}
// 校园应用学校分组-删除
export function campusDeleteGroups(params) {
  return request({
    url: `/campus/app/school/groups/`,
    method: 'DELETE',
    params: params
  });
}
// 校园应用学校分组-获取详细信息
export function campusAppSchoolGroup(id, params) {
  return request({
    url: `/campus/app/school/groups/${id}`,
    method: 'get',
    params: params
  });
}
// 校园应用学校分组-查询校园应用学校分组列表
export function campusAppGroupslist(campusAppId, params) {
  return request({
    url: `/campus/app/school/groups/list/${campusAppId}`,
    method: 'get',
    params: params
  });
}
